import { ArrowLeft } from "lucide-react";

type Props = {
    href: string;
    label: string;
};

export function BackToMeasurementForm({ href, label }: Props) {
    return (
        <a
            href={href}
            data-testid="back-to-measurement-form"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 cursor-pointer hover:text-primary"
        >
            <ArrowLeft className="size-4" aria-hidden="true" />
            {label}
        </a>
    );
}
